<div class="dialog-header">
  <h1 mat-dialog-title>
    <span><ng-container i18n>Create New Organization</ng-container></span>
  </h1>
  <p class="instructions">
    <ng-container i18n
      >Fill out the form below to create a new Organization</ng-container
    >
  </p>
</div>

<mat-dialog-content>
  <h4 class="uppercase"><ng-container i18n>Name</ng-container></h4>
  <mat-form-field style="width: 100%" appearance="outline">
    <input matInput [formControl]="nameControl" maxlength="50" autofocus />
    <mat-hint>{{ nameControl.value?.length }} / 50</mat-hint>
    <mat-error>
      @if (nameControl.touched && nameControl.errors?.['required']) {
        <ng-container i18n>Name can't be empty.</ng-container>
      }
      @if (nameControl.errors?.['maxlength']) {
        <ng-container i18n>Name can't exceed 50 characters.</ng-container>
      }
    </mat-error>
  </mat-form-field>
</mat-dialog-content>

<mat-dialog-actions>
  <section class="buttons uppercase">
    <button
      class="cancel-button"
      (click)="dialogRef.close(); nameControl.reset()">
      <ng-container i18n>Cancel</ng-container>
    </button>
    <button
      class="save-button"
      [disabled]="!nameControl.valid"
      (click)="onSubmit()">
      <ng-container i18n>Create</ng-container>
    </button>
  </section>
</mat-dialog-actions>
